<template>
  <!-- 这里放地图 -->
    <div class="container_flex" tabindex="0" hidefocus="true">
      <div class="top">
        <div class="top_left_wrapper">
          <div class="tab tabPointer" @click="navGoUrl('/')">旅游分析</div>
          <div class="tab tabPointer" @click="navGoUrl('/second')">
            街区信息态势
          </div>
          <div class="tab tabPointer tab_selected">街区商业概况</div>
        </div>
        <tool-bar></tool-bar>
      </div>

      <div class="main_content">
        <div class="midMap" id="idMidMap">
        </div>
        <div class="left">
          <left_1 :shop_state="shop_state" />
          <div class="left_list_wrapper">
            <left_3 :special_shop_distribution="special_shop_distribution" />
            <left_4 :business_facilities="business_facilities" />
          </div>
          <left_2 :consumer_struct="consumer_struct" />

        </div>

        <div class="center_main">
          <!-- <div class="center_tab">
						<div class="center_tab_1">高点位监控</div>
						<div class="center_tab_1 center_tab_1_selected">中点位监控</div>
						<div class="center_tab_1">低点位监控</div>
					</div> -->
        </div>

        <div class="right">
          <right_1 :mall_desc="mall_desc"></right_1>
          <right_2 :mall_revenue_state="mall_revenue_state"></right_2>
          <div class="left_list_wrapper">
            <right_3 :mall_category_distribution="mall_category_distribution" />
            <right_4 :suggestions="suggestions" />
          </div>
        </div>
      </div>

      <div class="bottom"></div>
    </div>
</template>

<script>

import * as uepixel from "../utils/ue-pixel"
import "@/assets/css/reset.css";
import toolBar from "@/components/ToolBar.vue";
import left_1 from "@/components/third/left_1.vue";
import left_2 from "@/components/third/left_2.vue";
import left_3 from "@/components/third/left_3.vue";
import left_4 from "@/components/third/left_4.vue";

import right_1 from "@/components/third/right_1.vue";
import right_2 from "@/components/third/right_2.vue";
import right_3 from "@/components/third/right_3.vue";
import right_4 from "@/components/third/right_4.vue";
import { getBusinessOverview } from "@/api/third";

export default {
  data () {
    return {
      // 商务配套设施
      business_facilities: null,
      // 消费客群结构
      consumer_struct: null,
      // 商业业态分布
      mall_category_distribution: null,
      // 商场简介
      mall_desc: null,
      // 街区店铺情况
      shop_state: null,
      // 特色商铺分布
      special_shop_distribution: null,
      // 建议
      suggestions: null,
      //营收情况
      mall_revenue_state: null,
      timer: null,
    };
  },
  components: {
    toolBar,
    left_1,
    left_2,
    left_3,
    left_4,
    right_1,
    right_2,
    right_3,
    right_4,
  },
  mounted () {
    let that = this;
    this.timer = setInterval(function () {
      that.getData()
    }, 600000)

    const config = {
      streamAddress: 'ws://110.80.12.170:7777',
      htmlElement: 'idMidMap',
      scene: 'jqsygk'
    }
    uepixel.init(config)
  },

  created () {
    this.getData();
  },
  beforeDestroy () {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    uepixel.close()
  },
  methods: {

    navGoUrl (url) {
      this.$router.push(url);
    },
    getData () {
      getBusinessOverview().then((res) => {
        this.shop_state = res.data.shop_state.dataList;
        this.consumer_struct = res.data.consumer_struct.dataList;
        this.special_shop_distribution = res.data.special_shop_distribution.dataList;
        this.business_facilities = res.data.business_facilities.dataList;
        this.mall_category_distribution = res.data.mall_category_distribution.dataList;
        this.mall_desc = res.data.mall_desc.dataList;
        this.suggestions = res.data.suggestions.dataList;
        this.mall_revenue_state = res.data.mall_revenue_state.dataList;

        console.log(res);
      }).catch(e => { });
    }
  },
};
</script>

<style scoped src="@/assets/css/index3.css" >
.midMap {
  width: 50%;
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  /* background-color: black; */
}
.left {
  z-index: 999;
}
.right {
  z-index: 999;
}
.center_main {
  width: 2468px;
  height: 200px !important;
  position: static !important ;
}
.main_content {
  width: 100%;
  height: 1389px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}
</style>

